import { useTranslation } from "next-i18next";
import { isKit } from "../../util/product/is-kit";
import styles from "./partNumber.module.scss";

const PartNumber = (props: any) => {
  const { product, className } = props;
  const { extendedDescription, partNumber } = product;
  let text = partNumber;
  const { t } = useTranslation("common");

  if (isKit(product)) {
    const { components } = extendedDescription;
    text = components.map((component: any) => component.partNumber).join(", ");
  }

  return (
    <span data-testid="item-part-number" className={`${styles.item_part_number} ${className}`}>
      {t("Part")}
      #
      &nbsp;
      {text}
    </span>
  );
};

export default PartNumber;
